import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class GestionService {

  readonly URL_API = this.config.getConfig().url

  constructor(private http: HttpClient, private config: ConfigService) { }

  public getInfo(page: number = 1, container: string = '', shiftClassId: number = 0) {
    return this.http.get(`${this.URL_API}/management?page=${page}&container=${container}&classShift=${shiftClassId}`);
  }

  public getCanceled(page: number = 1, container: string = '', classShift: number = 0){
    return this.http.get(`${this.URL_API}/management?page=${page}&container=${container}&classShift=${classShift}&status=false`);
  }

  public getShift(id: number) {
    return this.http.get(`${this.URL_API}/management/${id}`);
  }

  public createObvs(data: any, id: number){
    return this.http.put(`${this.URL_API}/management/save/${id}`, data);
  }
}
